import type { EffectSelectDto, EffectsSelectDto } from '@@types/api.types';
import { useAuth0 } from '@auth0/auth0-react';
import type { ApiErrorWrapper } from '@hooks/api.hook';
import { useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetEffects = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<EffectSelectDto[], ApiErrorWrapper, EffectSelectDto[]>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<EffectsSelectDto>({ path: '/v1/data/effects' });
      return result.effects;
    },
    queryKey: enabled ? queryKeys.effect.getEffects : queryKeys.placeholders.default,
  });
};
